import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { defineMessage, useIntl } from 'react-intl';

/** DOM id of the caret that opens the create / create-and-go menu. */
export const CREATE_FRAGMENT_SPLIT_SUBMIT_TOUR_ELEMENT_ID = 'create-fragment-split-submit-caret';

/**
 * One-time tour highlighting the split-submit caret so users discover
 * create-and-go-to-fragment in a single action.
 */
export function useCreateFragmentSplitSubmitTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour({ key: 'createFragmentSplitSubmit', expiry: '2026-09-29' }, {
    steps: [
      {
        element: `#${CREATE_FRAGMENT_SPLIT_SUBMIT_TOUR_ELEMENT_ID}`,
        popover: {
          title: $t(
            defineMessage({
              id: 'fragments.addScreen.splitSubmit.tour.title',
              defaultMessage: 'Crear e ir al fragmento',
            }),
          ),
          description: $t(
            defineMessage({
              id: 'fragments.addScreen.splitSubmit.tour.description',
              defaultMessage:
                'Usá este menú para crear el fragmento e ir al detalle en un solo paso.',
            }),
          ),
          side: 'top',
          align: 'end',
        },
      },
    ],
  } satisfies TourConfig);
}
